import { useChangeMyPasswordMutation } from './change-my-password.v5.generated';
import { useAuthChangePasswordUserMutationMutation as useChangePasswordMutation } from './change-password.v5.generated';

/**
 * Change the password of a learning user
 * You must use the org id and the user id from learning
 */
export const useChangePassword = () => {
  const [changePassword] = useChangePasswordMutation({
    context: {
      clientName: 'v5',
    },
  });

  return {
    changePassword,
  };
};

export const useChangeMyPassword = () => {
  const [changeMyPassword] = useChangeMyPasswordMutation({
    context: {
      clientName: 'v5',
    },
  });

  return {
    changeMyPassword,
  };
};
